export const workspaceSizeAlert = (workspace) => {
  if(workspace){
    if(Object.hasOwn(workspace, 'total_size') && workspace.total_size >= 90){
      return alert(`Storage is ${workspace.total_size}% full. Delete unnecessary files to increase storage. `)
    }
  }
}
